// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wechat-login__qrbox[data-v-5d9fcd88]{width:100%;min-height:400px;margin:23px auto 0}.wechat-login__qrbox--footer[data-v-5d9fcd88]{text-align:center;margin-top:20px;font-size:13px;line-height:16px;color:#333}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
